export default __webpack_public_path__ + "static/media/live-feed-regular-operation.c58b81c0.svg";